import { cn } from "@/lib";
import { ComponentProps } from "react";

interface IProps extends ComponentProps<"div"> {
  color?: string;
}

const Loader = ({ color = "bg-white", ...props }: IProps) => {
  const delays = [0, 0.25, 0.5];

  return (
    <div
      {...props}
      className={cn(
        "flex h-full w-full items-center justify-center gap-2",
        props.className,
      )}
    >
      {delays.map((delay, i) => (
        <div
          key={i}
          className={cn(
            "animate-bounce-scale aspect-square h-2/5 w-2/5 rounded-full",
            color,
          )}
          style={{ animationDelay: `${delay}s` }}
        />
      ))}
    </div>
  );
};

export default Loader;
